import { Fragment, useMemo, useContext } from 'react';

import { FlightStatusContext } from 'context';
import {
  compareDates,
  airportParser,
  findAirport,
  destinationTimesParser,
} from 'helpers';
import { MapTiler } from 'components';
import { Location } from '../';
import { FlightsWrapper, PlaneIcon } from './PlaneLocationWrapper.style';

const PlaneLocationWrapper = ({ flight }) => {
  const {
    state: { airports, modal, parsedDestinations },
  } = useContext(FlightStatusContext);
  const parsedFlight = useMemo(() => modal.id.split('-'), [modal.id]);

  const originLocation = useMemo(
    () =>
      parsedFlight &&
      airports &&
      parsedDestinations &&
      findAirport(parsedFlight[2], airports, parsedDestinations),
    [airports, parsedFlight, parsedDestinations]
  );

  const destinationLocation = useMemo(
    () =>
      parsedFlight &&
      airports &&
      parsedDestinations &&
      findAirport(parsedFlight[3], airports, parsedDestinations),
    [airports, parsedFlight, parsedDestinations]
  );

  const originAirport = useMemo(() => {
    return (
      airports &&
      originLocation?.fs &&
      airportParser(airports, originLocation?.fs)
    );
  }, [airports, originLocation]);

  const destinationAirport = useMemo(() => {
    return (
      airports &&
      destinationLocation?.fs &&
      airportParser(airports, destinationLocation?.fs)
    );
  }, [airports, destinationLocation]);

  const locationTime = useMemo(
    () =>
      flight?.operationalTimes &&
      destinationTimesParser(flight.operationalTimes),
    [flight]
  );

  const isSameDate = useMemo(
    () =>
      flight?.departureDate?.dateLocal &&
      flight?.arrivalDate?.dateLocal &&
      compareDates(
        flight?.departureDate.dateLocal,
        flight?.arrivalDate.dateLocal
      ),
    [flight]
  );

  return (
    <Fragment>
      <FlightsWrapper>
        <PlaneIcon />
        <Location
          direction="departure"
          time={locationTime}
          location={originLocation}
          airport={flight?.airportResources}
        />
        <Location
          direction="arrival"
          time={locationTime}
          location={destinationLocation}
          airport={flight?.airportResources}
          isSameDate={isSameDate}
        />
      </FlightsWrapper>
      {/* <MapTiler
        mode="modal"
        flightData={`${flight?.carrierFsCode}${flight?.flightNumber}-${
          flight?.flightId?.split('-')[1]
        }`}
        originAirport={originAirport}
        destinationAirport={destinationAirport}
      /> */}
    </Fragment>
  );
};

export default PlaneLocationWrapper;
